
import CaseStudy from 'components/CaseStudy';
import Layout from 'components/Layout';
import SEO from 'components/seo';
import React from 'react';

const CaseStudyPage = () => {
  return (
    <Layout>
      <SEO title='comachicart' path='case_study' />
      <CaseStudy />
    </Layout>
  );
};

export default CaseStudyPage;
